import { lccstore } from 'lcc-state';

import { create } from '@dojo/framework/core/vdom';
import { asMoment } from '@holmescorp/dates';
import { publish } from '@holmescorp/pub-sub';

import { svc } from '../support/svc';

const factory = create({});

export const NewAnnouncements = factory(() => {
	const get_announcements = async () => {
		const start = 0;
		const count = 100;
		const end = start + count;
		const all_announcements = await svc.announcements({
			session_id: window.hcstatic.course_session ? window.hcstatic.course_session.pk : undefined,
			select: {
				dstore: true,
				start,
				count,
				end,
				filter: {
					act: 'eq',
					args: ['published', true]
				}
			}
		});

		const new_announcements = all_announcements.filter((record) => {
			const { get, path } = lccstore;
			const sitestatus = get(path('sitestatus'));

			const pubdate = asMoment(record.pubdate);

			if (sitestatus.prior_login) {
				const prior = asMoment(sitestatus.prior_login);

				return pubdate.isAfter(prior);
			}

			return false;
		});

		publish('notifications/change-status', {
			hasNewNotifications: new_announcements.length > 0,
			newNotificationArea: 'AnnouncementsPane'
		});
	};

	get_announcements();

	return null;
});
